import { createRoute, redirect } from '@tanstack/react-router'
import { authenticatedRoute } from './_authenticated'

// D61 Phase 6 — Quick Search retired. The route now exists only to redirect
// stragglers (bookmarks, deep links) at /quick-search to the unified search
// box, focused, instead of rendering its own page. Same beforeLoad+redirect
// shape as indexRoute (index.tsx) — the redirect always fires unconditionally.
export const quickSearchRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/quick-search',
  beforeLoad: () => {
    throw redirect({ to: '/search', search: { focus: 'search' } })
  },
  component: () => null,
})
